import { render, staticRenderFns } from "./ClientAgencies.vue?vue&type=template&id=634842a4"
import script from "./ClientAgencies.vue?vue&type=script&lang=js"
export * from "./ClientAgencies.vue?vue&type=script&lang=js"
import style0 from "./ClientAgencies.vue?vue&type=style&index=0&id=634842a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports